module.exports = __webpack_public_path__ + "static/media/sgd-2.59342be8.png";